import Model from "@/models/Model";

export default class Completion extends Model {
    resource() {
        return "completions";
    }
}
